"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/radium/~/inline-style-prefixer/lib/utils/isPrefixedProperty.js
// module id = 3186
// module chunks = 4